import {StateLabel} from "@platform/models/state-labels/state-label"

export const LastSeenLabels: Map<"today" | "before", StateLabel<"today" | "before">> = new Map<"today" | "before", StateLabel<"today" | "before">>([
    ["today", {state: "today", label: "Today"}],
    ["before", {state: "before", label: "Before today"}],
])
